import { render, staticRenderFns } from "./SelectCurrency.vue?vue&type=template&id=399f5a96&scoped=true&"
import script from "./SelectCurrency.vue?vue&type=script&lang=js&"
export * from "./SelectCurrency.vue?vue&type=script&lang=js&"
import style0 from "./SelectCurrency.vue?vue&type=style&index=0&id=399f5a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f5a96",
  null
  
)

export default component.exports